const Icons = {
    homeImage: require("../assets/images/homeImg.png"),
    logo: require("../assets/images/logo.png"),
    phoneSimulator: require("../assets/images/phoneSimulator.png"),
    zabali: require("../assets/images/zabali.png"),
    blackHomeImage: require("../assets/images/blackHomeImg.png"),
    aboutUs: require("../assets/images/about.png"),
    teamMembers: require("../assets/images/team.png"),
    career: require("../assets/images/career.png"),

    project: require("../assets/images/project.png"),
    enviournment: require("../assets/images/enviournment.png"),
    oppournities: require("../assets/images/opportunities.png"),
    salary: require("../assets/images/salary.png"),


    mobileIcon: require("../assets/icons/mobile.png"),
    graphicsIcon: require("../assets/icons/graphics.png"),
    webIcon: require("../assets/icons/web.png"),

    expertiseIcon: require("../assets/icons/expertise.png"),
    clientIcon: require("../assets/icons/client.png"),
    scalableIcon: require("../assets/icons/scalable.png"),
    deadlineIcon: require("../assets/icons/deadlines.png"),


    facebookIcon: require("../assets/icons/facebook.png"),
    instagramIcon: require("../assets/icons/instagram.png"),
    linkedInIcon: require("../assets/icons/linkedin.png"),

    creativeIcon: require("../assets/icons/creative.png"),
    solutionIcon: require("../assets/icons/solutions.png"),
    customerIcon: require("../assets/icons/customer.png"),
    staticsIcon: require("../assets/icons/statics.png"),
    verifiedIcon: require("../assets/icons/verified.png"),
    closeIcon: require("../assets/icons/close.png"),
  };
  
  export default Icons;
  